
import Vue from 'vue'
import { EntityService } from '@/services/entity.service'
import { validationMixin } from 'vuelidate'
import { required, maxValue, minValue, numeric, decimal } from 'vuelidate/lib/validators'

const entityService = new EntityService()

export default Vue.extend({
  name: 'RetentionEdit',
  mixins: [validationMixin],
  validations: {
    form: {
      retentionTax: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue: maxValue(100)
      },
      retention1: {
        required,
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(100)
      },
      retention2: {
        required,
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(100)
      }
    }
  },
  props: ['value', 'editEntity'],
  data: () => ({
    entity: 'suppliers',
    isLoading: false,
    projects: [],
    form: {
      id: 0,
      retentionTax: 0,
      retention1: 0,
      retention2: 0
    },
    form2: {}
  }),
  async created () {
    this.projects = await entityService.getList('projects')
    this.form = {
      id: this.editEntity.id,
      retentionTax: this.editEntity.tax,
      retention1: this.editEntity.retention_1,
      retention2: this.editEntity.retention_2
    }
  },
  methods: {
    toggleModal (value: boolean) {
      this.$emit('input', value)
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoading = true
        console.log(this.form)
        this.form2 = {
          tax: this.form.retentionTax,
          // eslint-disable-next-line @typescript-eslint/camelcase
          retention_1: this.form.retention1,
          // eslint-disable-next-line @typescript-eslint/camelcase
          retention_2: this.form.retention2
        }
        await entityService.updateEntity(this.editEntity.id, this.entity, this.form2)
        this.isLoading = false
        this.$emit('input', false)
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  }
})
